import { render, staticRenderFns } from "./NewBetslip.vue?vue&type=template&id=36239db9"
import script from "./NewBetslip.vue?vue&type=script&lang=js"
export * from "./NewBetslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports